import React from "react";
import Switch from "react-switch";

import collapsed from "./../../../UI/general/collapse.svg";
import close from "./../../../UI/general/close.svg";

/*eslint-disable*/

interface Props {
  colorsData: any;
  inmueblesData: any;
  attributesFilterObject: any;
  handleUpdateFilterObject: any;
  handlePropertiesFilter: any;
  avalabilityAttributesToShow: any;
  handleFilterAvailability: any;
  handleMenuSelection: any;
  handleClearFilters: any;
  isProperties: any;
  hasDispo: boolean;
  detailedGroupID: any;
  layoutsRef: any;
  handleHideTooltip: any;
}

interface State {
  isCollapsed: boolean;
  currentFilteredProperty: string;
  showDispo: boolean;
  showFilterByAttribute: boolean;
  filteredDropdownAttributes: any;
  openedDropdown: any;
  attributesToFilter: any;
}

class SidebarProperties extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isCollapsed: true,
      currentFilteredProperty: "",
      showDispo: true,
      showFilterByAttribute: true,
      filteredDropdownAttributes: [],
      openedDropdown: [],
      attributesToFilter: [],
    };
  }

  componentDidMount(): void {
    var filteredAttributes: any = {};

    this.props.inmueblesData.properties.attributes.map(
      (attribute: any, index: number) => {
        if (attribute.active === 1) {
          filteredAttributes[attribute.id] = [];
        }
      }
    );

    this.setState({
      filteredDropdownAttributes: filteredAttributes,
      attributesToFilter: this.props.inmueblesData.properties.attributes,
    });
    this.setState({
      isCollapsed: !this.props.isProperties,
    });
  }

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
    snapshot?: any
  ): void {
    if (prevProps.isProperties !== this.props.isProperties) {
      this.setState({
        isCollapsed: !this.props.isProperties,
      });
    }
  }

  /*handleChangeValue = (attributeId: string, filterValue: string) => {
    this.props.attributesFilterObject[attributeId] = filterValue;
    this.props.handleUpdateFilterObject(this.props.attributesFilterObject);

    var filtered: any = {}

    var tempObject: any = this.props.inmueblesData.properties.property


    Object.keys(this.props.attributesFilterObject).map((key: any) => {
      var tempProperties: any = []
      if(this.props.attributesFilterObject[key] !== '' && Array.isArray(this.props.attributesFilterObject[key]) === false){
        tempObject.map((inmueble: any) => {
          inmueble.values.map((value: any) => {
            if(value.value === this.props.attributesFilterObject[key] && key === value.attribute){
              tempProperties.push(inmueble)
            }
          })
        })
        tempObject = tempProperties
      }
    })

    tempObject.map((inmuebles: any) => {
      inmuebles.values.map((value: any) => {
        var tempObject = {
          value: value.value,
          attribute: value.attribute,
          state: value.state,
          type: value.type
        }
        if(filtered.hasOwnProperty(value.attribute) && !filtered[value.attribute].includes(JSON.stringify(tempObject))){
          filtered[value.attribute].push(JSON.stringify(tempObject))
        }
        else if(!filtered.hasOwnProperty(value.attribute)){
          filtered[value.attribute] = [JSON.stringify(tempObject)]
        }
      })
    })

    Object.keys(filtered).map((key: any) => {
      filtered[key].map((value: any, index: number) => {
        filtered[key][index] = JSON.parse(value)
      })
    })

    var newFilter = this.props.inmueblesData.properties.attributes

    Object.keys(newFilter).map((key: any) => {
      newFilter[key].values = filtered[newFilter[key].id] ? filtered[newFilter[key].id]: newFilter[key].values
    })

    this.setState({
      attributesToFilter: newFilter
    })
  };*/

  handleChangeValueDropdown = (attributeId: string, filterValue: string) => {
    if (
      this.props.attributesFilterObject[attributeId].includes(filterValue) ===
      false
    ) {
      if (this.props.attributesFilterObject[attributeId] === "") {
        this.props.attributesFilterObject[attributeId] = [];
      }
      this.props.attributesFilterObject[attributeId].push(filterValue);
    } else {
      if (this.props.attributesFilterObject[attributeId] === "") {
        this.props.attributesFilterObject[attributeId] = [];
      }
      this.props.attributesFilterObject[attributeId].splice(
        this.props.attributesFilterObject[attributeId].indexOf(filterValue),
        1
      );
    }
    this.props.handleUpdateFilterObject(this.props.attributesFilterObject);
  };

  handleFilterMultiple = (attributeId: string, filterValue: string) => {
    //console.log(attributeId, filterValue);
    
    var tempObject = this.props.attributesFilterObject;
    if (filterValue === "") {
      tempObject[attributeId] = [];
    } else if (tempObject[attributeId].includes(filterValue)) {
      tempObject[attributeId].splice(
        tempObject[attributeId].indexOf(filterValue),
        1
      );
    } else {
      tempObject[attributeId].push(filterValue);
    }

    this.props.handleUpdateFilterObject(tempObject);
  };

  handleAddValueToDropdown = (attributeId: string, filteredValue: string) => {
    if (
      this.state.filteredDropdownAttributes[attributeId].includes(
        filteredValue
      ) === false
    ) {
      this.state.filteredDropdownAttributes[attributeId].push(filteredValue);
      this.setState({
        filteredDropdownAttributes: this.state.filteredDropdownAttributes,
      });
    } else {
      this.state.filteredDropdownAttributes[attributeId].splice(
        this.state.filteredDropdownAttributes[attributeId].indexOf(
          filteredValue
        ),
        1
      );
      this.setState({
        filteredDropdownAttributes: this.state.filteredDropdownAttributes,
      });
    }
  };

  handleAddCleanToDropdown = (attributeId: string, filteredValue: string) => {
    this.state.filteredDropdownAttributes[attributeId] = [];
    this.setState({
      filteredDropdownAttributes: this.state.filteredDropdownAttributes,
    });
  };

  handleAddToArray = (payload: number) => {
    var tempArray = this.state.openedDropdown;
    if (tempArray.includes(payload)) {
      tempArray.splice(tempArray.indexOf(payload), 1);
    } else {
      tempArray.push(payload);
    }
    this.setState({
      openedDropdown: tempArray,
    });
  };

  render(): React.ReactNode {
    return (
      <React.Fragment>
        <div
          className={
            this.state.isCollapsed
              ? "sidebar-properties-collapse-btn-collapsed"
              : "sidebar-properties-collapse-btn"
          }
          onClick={() => {
            this.setState({
              isCollapsed: !this.state.isCollapsed,
            });
          }}
        >
          <img src={collapsed} alt="" />
        </div>
        <div
          className={
            this.state.isCollapsed
              ? "sidebar-properties-collapsed"
              : "sidebar-properties"
          }
          onClick={(e) => {
            this.setState({
              openedDropdown: [],
            });
            e.preventDefault();
            e.stopPropagation();
            if (this.props.layoutsRef.current) {
              this.props.handleHideTooltip();
              this.props.layoutsRef.current.setState({
                currentSelectedProperty: "",
              });
            }
          }}
        >
          <div
            className="properties-close-btn"
            onClick={() => {
              this.setState({
                isCollapsed: true,
              });
              setTimeout(() => {
                this.props.handleMenuSelection("");
              }, 500);
            }}
          >
            <img src={close} alt=""></img>
          </div>
          <div className="properties-img-container">
            <img src={"./UI/properties/properties.svg"} alt=""></img>
          </div>
          <div className="properties-text">INMUEBLES</div>
          <div className="properties-filters-container">
            {/*
              <div className="search-property-container">
              <div className="search-property-text">Buscar inmueble</div>
              <input type="text" className="input-search-property"></input>
            </div>
          */}
            <hr className="hr-search-property"></hr>
            {this.props.hasDispo ? (
              <div className="availability-container">
                <div
                  className="availabilty-open-close-btn"
                  onClick={() => {
                    this.setState({
                      showDispo: !this.state.showDispo,
                    });
                  }}
                >
                  <div className="availability-name">DISPONIBILIDAD</div>
                  <img
                    src={collapsed}
                    alt=""
                    className={
                      this.state.showDispo
                        ? "properties-dispo-show"
                        : "properties-dispo-collapsed"
                    }
                  />
                </div>
                <div
                  className={
                    this.state.showDispo && this.props.isProperties
                      ? "availability-options-container-opened"
                      : "availability-options-container"
                  }
                >
                  {this.state.showDispo ? (
                    <React.Fragment>
                      {this.props.inmueblesData.state_disponible ? <div className="avail-option">
                        <Switch
                          checked={this.props.avalabilityAttributesToShow.includes(
                            "DISPONIBLE"
                          )}
                          onChange={() => {
                            this.props.handleFilterAvailability("DISPONIBLE");
                          }}
                          onColor="#96EAA1"
                          checkedIcon={false}
                          uncheckedIcon={false}
                          onHandleColor="#5AE26C"
                          height={12}
                          width={25}
                          handleDiameter={16}
                          className="switch-mobile"
                        />
                        <div className="avail-option-name">Disponible</div>
                      </div> : null}
                      {this.props.inmueblesData.state_vendido ? <div className="avail-option">
                        <Switch
                          checked={this.props.avalabilityAttributesToShow.includes(
                            "VENDIDO"
                          )}
                          onChange={() => {
                            this.props.handleFilterAvailability("VENDIDO");
                          }}
                          onColor="#EB9797"
                          checkedIcon={false}
                          uncheckedIcon={false}
                          onHandleColor="#EE3F3F"
                          height={12}
                          width={25}
                          handleDiameter={16}
                          className="switch-mobile"
                        />
                        <div className="avail-option-name">Vendido</div>
                      </div> : null}
                      {this.props.inmueblesData.state_reservado ? <div className="avail-option">
                        <Switch
                          checked={this.props.avalabilityAttributesToShow.includes(
                            "RESERVADO"
                          )}
                          onChange={() => {
                            this.props.handleFilterAvailability("RESERVADO");
                          }}
                          onColor="#FFAA28"
                          checkedIcon={false}
                          uncheckedIcon={false}
                          onHandleColor="#FFBF4F"
                          height={12}
                          width={25}
                          handleDiameter={16}
                          className="switch-mobile"
                        />
                        <div className="avail-option-name">Reservado</div>
                      </div> : null}
                      {this.props.inmueblesData.state_no_disponible ? <div className="avail-option">
                        <Switch
                          checked={this.props.avalabilityAttributesToShow.includes(
                            "NO DISPONIBLE"
                          )}
                          onChange={() => {
                            this.props.handleFilterAvailability(
                              "NO DISPONIBLE"
                            );
                          }}
                          onColor="#A6A6A6"
                          checkedIcon={false}
                          uncheckedIcon={false}
                          onHandleColor="#434343"
                          height={12}
                          width={25}
                          handleDiameter={16}
                          className="switch-mobile"
                        />
                        <div className="avail-option-name">No disponibles</div>
                      </div> : null}
                    </React.Fragment>
                  ) : null}
                </div>
              </div>
            ) : null}
            {this.props.hasDispo ? <hr /> : null}
            <div
              className="filter-by-attribute-container"
              style={{
                maxHeight: !this.props.hasDispo
                  ? "100%"
                  : this.state.showDispo
                  ? "90%"
                  : "100%",
              }}
            >
              <div
                className="filter-by-attribute-open-close-btn"
                onClick={() => {
                  this.setState({
                    showFilterByAttribute: !this.state.showFilterByAttribute,
                  });
                }}
              >
                <div className="filter-name">FILTRAR POR ATRIBUTOS</div>
                <img
                  src={collapsed}
                  alt=""
                  className={
                    this.state.showFilterByAttribute
                      ? "properties-dispo-show"
                      : "properties-dispo-collapsed"
                  }
                />
              </div>
              <div
                className={
                  this.state.showFilterByAttribute && this.props.isProperties
                    ? "filter-options-container-opened"
                    : "filter-options-container"
                }
                style={{
                  maxHeight: !this.props.hasDispo
                    ? "80vh"
                    : this.state.showDispo
                    ? "63vh"
                    : "75vh",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.setState({
                    openedDropdown: [],
                  });
                }}
              >
                <div
                  className="filter-options-general-container"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  {this.state.attributesToFilter.map(
                    (attributes: any, index: number) =>
                      attributes.active === 1 ? (
                        <div
                          className="property-filter-individual-container"
                          key={attributes.name + index}
                        >
                          <div className="property-filter-individual-name">
                            {attributes.name}
                          </div>
                          {attributes.values &&
                          attributes.values.length <= 9 ? (
                            <div className="property-attribute-options-container">
                              <div
                                className="property-attrbiute-individual-option"
                                style={{
                                  backgroundColor:
                                    this.props.attributesFilterObject[
                                      attributes.id
                                    ].length === 0
                                      ? this.props.colorsData.main_buttons
                                      : "",
                                  color:
                                    this.props.attributesFilterObject[
                                      attributes.id
                                    ].length === 0
                                      ? this.props.colorsData.secondary_text
                                      : "",
                                  minWidth: "5.5rem",
                                  transition: "all 0.3s ease-in-out",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.setState({
                                    openedDropdown: [],
                                  });
                                  if (this.props.layoutsRef.current) {
                                    this.props.handleHideTooltip();
                                    this.props.layoutsRef.current.setState({
                                      currentSelectedProperty: "",
                                    });
                                  }
                                  this.handleFilterMultiple(attributes.id, "");
                                }}
                              >
                                Ver Todos
                              </div>
                              {attributes.values.map(
                                (value: any, indexValue: number) => (
                                  <div
                                    key={value.value + indexValue}
                                    className="property-attrbiute-individual-option"
                                    style={{
                                      backgroundColor:
                                        this.props.attributesFilterObject[
                                          attributes.id
                                        ].includes(value.value)
                                          ? this.props.colorsData.main_buttons
                                          : "",
                                      color: this.props.attributesFilterObject[
                                        attributes.id
                                      ].includes(value.value)
                                        ? this.props.colorsData.secondary_text
                                        : "",
                                      transition: "all 0.3s ease-in-out",
                                      minWidth:
                                        value.value.split(" ").length > 1
                                          ? "5.5rem"
                                          : "none",
                                      paddingRight:
                                        value.value.split(" ").length > 1
                                          ? "none"
                                          : "0.75rem",
                                      paddingLeft:
                                        value.value.split(" ").length > 1
                                          ? "none"
                                          : "0.75rem",
                                    }}
                                    onClick={() => {
                                      this.handleFilterMultiple(
                                        attributes.id,
                                        value.value
                                      );
                                    }}
                                    data-type={"FILTRO"}
                                    data-value={value.id}
                                  >
                                    {value.value}
                                  </div>
                                )
                              )}
                            </div>
                          ) : (
                            <div className="properties-dropdown">
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.handleAddToArray(index);
                                  if (this.props.layoutsRef.current) {
                                    this.props.handleHideTooltip();
                                    this.props.layoutsRef.current.setState({
                                      currentSelectedProperty: "",
                                    });
                                  }
                                  /*this.setState({
                                    dropdownOpened: !this.state.dropdownOpened,
                                  });*/
                                }}
                                className="dropdown-open-btn"
                              >
                                <div className="dropdown-open-text">
                                  {this.state.filteredDropdownAttributes[
                                    attributes.id
                                  ] &&
                                  this.state.filteredDropdownAttributes[
                                    attributes.id
                                  ].length === 0
                                    ? "Todos"
                                    : this.state.filteredDropdownAttributes[
                                        attributes.id
                                      ] &&
                                      this.state.filteredDropdownAttributes[
                                        attributes.id
                                      ].length > 2
                                    ? this.state.filteredDropdownAttributes[
                                        attributes.id
                                      ][0] +
                                      ", " +
                                      this.state.filteredDropdownAttributes[
                                        attributes.id
                                      ][1] +
                                      ", ..."
                                    : this.state.filteredDropdownAttributes[
                                        attributes.id
                                      ]
                                    ? this.state.filteredDropdownAttributes[
                                        attributes.id
                                      ].join(", ")
                                    : null}
                                </div>
                                <div className="dropdown-arrow-container">
                                  <img src={collapsed} alt="" className={""} />
                                </div>
                              </div>
                              {
                                <div
                                  className={
                                    this.state.openedDropdown.includes(index)
                                      ? "properties-dropdown-options"
                                      : "properties-dropdown-options-collapsed"
                                  }
                                  style={{
                                    height: this.state.openedDropdown.includes(
                                      index
                                    )
                                      ? (attributes.values.length + 1) * 2.5 +
                                        "vh"
                                      : "0vh",
                                  }}
                                >
                                  {this.state.openedDropdown.includes(index) ? (
                                    <React.Fragment>
                                      <div className="properties-dropdown-individual-option">
                                        <input
                                          type="checkbox"
                                          checked={
                                            this.props.attributesFilterObject[
                                              attributes.id
                                            ] === "" ||
                                            this.props.attributesFilterObject[
                                              attributes.id
                                            ].length === 0
                                          }
                                          onChange={() => {
                                            this.handleAddCleanToDropdown(
                                              attributes.id,
                                              ""
                                            );
                                            this.handleFilterMultiple(
                                              attributes.id,
                                              ""
                                            );
                                          }}
                                        ></input>
                                        <div>{"Seleccionar todos"}</div>
                                      </div>
                                      <hr />
                                      {attributes.values.map(
                                        (value: any, indexValue: number) => (
                                          <div
                                            className="properties-dropdown-individual-option"
                                            key={value.value + indexValue}
                                            onClick={(e) => {}}
                                          >
                                            <input
                                              type="checkbox"
                                              onChange={() => {
                                                this.handleAddValueToDropdown(
                                                  attributes.id,
                                                  value.value
                                                );
                                                this.handleChangeValueDropdown(
                                                  attributes.id,
                                                  value.value
                                                );
                                              }}
                                              data-type={"FILTRO"}
                                              data-value={value.id}
                                              checked={this.props.attributesFilterObject[
                                                attributes.id
                                              ].includes(value.value)}
                                            ></input>
                                            <div>{value.value}</div>
                                          </div>
                                        )
                                      )}
                                    </React.Fragment>
                                  ) : null}
                                </div>
                              }
                            </div>
                          )}
                        </div>
                      ) : null
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SidebarProperties;
